module.exports = __webpack_public_path__ + "static/img/stock.0753d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock.png
// module id = 5NNj
// module chunks = 1